// extracted by mini-css-extract-plugin
module.exports = {"container":"NotesCard_container__1gc6U","card":"NotesCard_card__2NJpQ","edit":"NotesCard_edit__3NNUf","left":"NotesCard_left__3tnND","right":"NotesCard_right__3gGFW"};